import React from 'react';
import { UnmountClosed as Collapse } from 'react-collapse';

import Switch from '../../../UI/Switch';
import TabButtons from '../../../UI/TabButtons';
import { NOTIFICATION_TIME_UNITS } from '../../../../lib/notification_utils';

export default ({ label, helpText, rule, onToggle, onValueChange, onUnitChange }) => {
  if (!rule) {
    return null;
  }

  return (
    <div className="notification-setting__field-container">
      <div className="notification-setting__field">
        <div>{label}</div>
        <Switch isEnabled={!!rule.get('enabled')} onToggle={onToggle} />
      </div>

      {!!helpText && <div className="notification-setting__help-text">{helpText}</div>}

      <Collapse isOpened={!!rule.get('enabled')} springConfig={{ stiffness: 300 }}>
        <div className="notification-lead-time-container">
          <input
            type="number"
            min="0"
            className="textfield notification-lead-time-value-textfield"
            value={rule.get('value')}
            onChange={onValueChange}
          />
          <TabButtons
            buttons={NOTIFICATION_TIME_UNITS}
            titles={['minutes', 'hours', 'days', 'weeks']}
            selectedButton={rule.get('unit')}
            onSelect={onUnitChange}
          />
        </div>
      </Collapse>
    </div>
  );
};
